export default __webpack_public_path__ + "static/media/lock.b5b316c7.svg";